export type VolumeBonusBrand = 'Omet' | 'MPS' | 'Bobst' | 'Durst' | 'GF' | 'DCMQ'

export interface VolumeBonusBracket {
    maxExclusive?: number
    minInclusive?: number
    coefficient: number
}

/** Пороги по объёму: min(факт_дл, расч_дл) × факт_шир. */
export const VOLUME_BONUS_BRACKETS: Record<
    Exclude<VolumeBonusBrand, 'GF' | 'DCMQ'>,
    VolumeBonusBracket[]
> = {
    Omet: [
        { maxExclusive: 45000, coefficient: 0.8 },
        { minInclusive: 45000, maxExclusive: 55000, coefficient: 0.99 },
        { minInclusive: 55000, coefficient: 1.15 },
    ],
    MPS: [
        { maxExclusive: 35000, coefficient: 0.92 },
        { minInclusive: 35000, maxExclusive: 45000, coefficient: 1.07 },
        { minInclusive: 45000, coefficient: 1.2 },
    ],
    Bobst: [
        { maxExclusive: 30000, coefficient: 1 },
        { minInclusive: 30000, maxExclusive: 40000, coefficient: 1.1 },
        { minInclusive: 40000, coefficient: 1.33 },
    ],
    Durst: [
        { maxExclusive: 30000, coefficient: 0.9 },
        { minInclusive: 30000, maxExclusive: 35000, coefficient: 1.15 },
        { minInclusive: 35000, coefficient: 1.38 },
    ],
}

/** Пороги по суммарной фактической длине, км (не объём). */
export const GF_LENGTH_BONUS_BRACKETS: VolumeBonusBracket[] = [
    { maxExclusive: 55, coefficient: 400 },
    { minInclusive: 55, maxExclusive: 65, coefficient: 480 },
    { minInclusive: 65, coefficient: 530 },
]

export const DCMQ_BONUS_COEFFICIENT = 0.38

const BRAND_NAME_ALIASES: Record<string, VolumeBonusBrand | undefined> = {
    omet: 'Omet',
    mps: 'MPS',
    bobst: 'Bobst',
    durst: 'Durst',
    gf: 'GF',
    rg: 'GF',
    dcmq: 'DCMQ',
}

export function normalizeMachineBrandName(name: string | undefined): VolumeBonusBrand | undefined {
    if (!name) return undefined

    const normalized = name.trim().toLowerCase()

    return BRAND_NAME_ALIASES[normalized]
}

function matchesBracket(value: number, bracket: VolumeBonusBracket): boolean {
    if (bracket.minInclusive != null && value < bracket.minInclusive) {
        return false
    }

    if (bracket.maxExclusive != null && value >= bracket.maxExclusive) {
        return false
    }

    return true
}

export function lookupBracketCoefficient(
    value: number,
    brackets: VolumeBonusBracket[]
): number | undefined {
    const bracket = brackets.find(item => matchesBracket(value, item))

    return bracket?.coefficient
}

export function lookupVolumeBonusCoefficient(
    brand: Exclude<VolumeBonusBrand, 'GF' | 'DCMQ'>,
    volume: number
): number | undefined {
    return lookupBracketCoefficient(volume, VOLUME_BONUS_BRACKETS[brand])
}

export function lookupGfLengthBonus(factLengthKm: number): number | undefined {
    return lookupBracketCoefficient(factLengthKm, GF_LENGTH_BONUS_BRACKETS)
}
